module.exports = __webpack_public_path__ + "img/product1.61171950.jpg";